import { render, staticRenderFns } from "./due-date-chicklet.vue?vue&type=template&id=1cc74a33&"
import script from "./due-date-chicklet.vue?vue&type=script&lang=ts&"
export * from "./due-date-chicklet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports